"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialModuleYandex = void 0;
var interfaces_1 = require("@dp-instant/interfaces");
var social_1 = require("@dp-instant/social");
var inversify_1 = require("inversify");
var CookieDataYandex_1 = require("./data/CookieDataYandex");
var LeaderboardGlobalYandex_1 = require("./model/LeaderboardGlobalYandex");
var PaymentsModelYandex_1 = require("./model/PaymentsModelYandex");
var SocialModelYandex_1 = require("./model/SocialModelYandex");
var UserYandex_1 = require("./model/user/UserYandex");
exports.SocialModuleYandex = new inversify_1.ContainerModule(function (bind) {
    bind(interfaces_1.TypesSocial.model).to(SocialModelYandex_1.SocialModelYandex).inSingletonScope();
    bind(interfaces_1.TypesSocial.cookie).to(CookieDataYandex_1.CookieDataYandex).inSingletonScope();
    bind(interfaces_1.TypesSocial.payments).to(PaymentsModelYandex_1.PaymentsModelYandex);
    bind(interfaces_1.TypesSocial.user).to(UserYandex_1.UserYandex);
    bind(interfaces_1.TypesSocial.userScore).to(social_1.UserScore);
    bind(interfaces_1.TypesSocial.leaderboardGlobal).to(LeaderboardGlobalYandex_1.LeaderboardGlobalYandex).inSingletonScope();
    bind(interfaces_1.TypesSocial.leaderboardContext).to(social_1.LeaderboardGlobalExternal).inSingletonScope();
    var dummyUser;
    bind(interfaces_1.TypesSocial.dummyUser).toDynamicValue(function (context) {
        if (!dummyUser) {
            dummyUser = context.container.get(interfaces_1.TypesSocial.user);
            var photo_1 = URL.createObjectURL(new Blob([
                "\n            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"320\" height=\"320\">\n                <path d=\"M0 0h320v320H0V0z\" fill=\"#fff\"/>\n                <path d=\"M320 0H0v320h320V0zM160 66.7c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 189.3c-33.4 0-62.7-17.1-80-42.9.3-26.5 53.4-41.1 80-41.1s79.6 14.6 80 41.1c-17.3 25.8-46.6 42.9-80 42.9z\"/>\n            </svg>"
            ], { type: "image/svg+xml" }));
            dummyUser.init({
                getUniqueID: function () { return "unknown"; },
                getPhoto: function () { return photo_1; }
            });
        }
        return dummyUser;
    });
});
//# sourceMappingURL=SocialModuleYandex.js.map